export default "__VITE_ASSET__QAzyXrTk__"